import { render, staticRenderFns } from "./infobox.vue?vue&type=template&id=e480e8c2&scoped=true"
import script from "./infobox.vue?vue&type=script&lang=js"
export * from "./infobox.vue?vue&type=script&lang=js"
import style0 from "./infobox.vue?vue&type=style&index=0&id=e480e8c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e480e8c2",
  null
  
)

export default component.exports